import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { getCurrencyFormat } from '../../../global/helpers/format-helpers';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { MyCpgPodsSettings, MyCpgPodsTypes, PodContent, RsvpData } from '../mycpg-pod-models';
import { PodGridContent } from './pod-grid-content';
import { PodGridContentItem } from './pod-grid-content-item';
import { PodGridItem } from './pod-grid-item';
import { PodGridItemHeader } from './pod-grid-item-header';


interface Props {
	settings: MyCpgPodsSettings;
}
export function RsvpPod(props: Props) {

	const { settings } = props;
	const rsvpPlan = useSelector<TcsmStates, RsvpData>(state => state?.mycpgPodsState?.pods?.rsvp_data);
	const routeMatch = useRouteMatch();
	const noPlan = rsvpPlan?.content === PodContent.NOT_ENROLLED;


	if (rsvpPlan?.show_pod === YesNoIndicators.No) {
		return null;
	}

	const renderContent = () => {
		if (rsvpPlan?.content === PodContent.NOT_ENROLLED) {
			return (
				<PodGridContentItem>
					<div dangerouslySetInnerHTML={{ __html: settings?.rsvpNoPlanText }} />
				</PodGridContentItem>);
		}

		return (
			<PodGridContentItem>
				<p className='h3-styled'>{getCurrencyFormat(rsvpPlan?.data?.total_balance)}</p>
				<p className='grey-caption'>{settings?.balanceDateLabel?.replace('{date}', rsvpPlan?.data?.as_of_date)}</p>
			</PodGridContentItem>
		);
	};

	return (
		<PodGridItem>
			<PodGridItemHeader title={settings?.rsvpPlanTitle}>
				<Link to={`${routeMatch?.path}?type=${MyCpgPodsTypes.RSVP}`}>{noPlan ? settings?.learnMoreText : settings?.seeMoreLinkText}</Link>
			</PodGridItemHeader>
			<PodGridContent>
				{renderContent()}
			</PodGridContent>
		</PodGridItem>
	);

}

